export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            欢迎视频平台运营方联系入驻，或有任何建议与反馈都可通过以下方式联系我们
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿/合作</h3>
                <p className="text-xs text-foreground-500">contact@example.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-chat-3-line text-xl text-accent-700"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
                <p className="text-xs text-foreground-500">feedback@example.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-links-line text-xl text-secondary-700"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">平台入驻</h3>
                <p className="text-xs text-foreground-500">join@example.com</p>
              </div>
            </div>
            <div className="mt-6 pt-6 border-t border-background-200/70 text-center">
              <p className="text-xs text-foreground-400">
                我们会在收到信息后的 1-3 个工作日内回复，感谢您的关注与支持
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}